import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class ActiveWorkersWoMandatoryPPECfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class ActiveWorkersWoMedicalExaminationCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
}

export class OccupationalRiskPreventionKpiCfg {
  public activeWorkersWoMandatoryPPE: ActiveWorkersWoMandatoryPPECfg;
  public pendingActiveWorkersWoMedicalExamination: ActiveWorkersWoMedicalExaminationCfg;
  public expiredActiveWorkersWoMedicalExamination: ActiveWorkersWoMedicalExaminationCfg
  public processingActiveWorkersWoMedicalExamination: ActiveWorkersWoMedicalExaminationCfg;
  public fitActiveWorkersWoMedicalExamination: ActiveWorkersWoMedicalExaminationCfg;
}

@Injectable()
export class OccupationalRiskPreventionKpiCfgService extends CfgService<OccupationalRiskPreventionKpiCfg> {
  json: any = {
    activeWorkersWoMandatoryPPE: {
      summaryEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomandatoryppe?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomandatoryppe/detail?beginDate={1}&endDate={2}"
    },
    pendingActiveWorkersWoMedicalExamination: {
      summaryEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/1?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/1/detail?beginDate={1}&endDate={2}"
    },
    expiredActiveWorkersWoMedicalExamination: {
      summaryEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/2?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/2/detail?beginDate={1}&endDate={2}"
    },
    processingActiveWorkersWoMedicalExamination: {
      summaryEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/3?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/3/detail?beginDate={1}&endDate={2}"
    },
    fitActiveWorkersWoMedicalExamination: {
      summaryEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/4?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{DashboardApiUrl}/riskprevention/{0}/activeworkerswomedicalexamination/4/detail?beginDate={1}&endDate={2}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/occupationalRiskPreventionKpi.cfg.json`;
  }

  /**
* Carga las url en el json
*/
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
